export default "__VITE_ASSET__BlsF3TDC__"